import { createSlice } from '@reduxjs/toolkit';

export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState: {
        global: {}
    },
    reducers: {
        errorGlobal: (state, action) => {
            // Access to global state
            state.global.error = true;
            state.global.msg = action.payload;
        },
        successGlobal:(state, action) => {
            state.global.success = true;
            state.global.msg = action.payload;
        },
        warningGlobal: (state, action) => {
            state.global.warning = true;
            state.global.msg = action.payload;
        },
        clearNotifications: (state) => {
            // Global back to defaut
            state.global = {}
        }
    }
});

export const { errorGlobal, successGlobal, warningGlobal, clearNotifications } = notificationsSlice.actions;
export default notificationsSlice.reducer;
